<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <Table ref="table" :tableData="tableData" :cols="cols" :btns="btns" :page="page" :limit="limit" :total="total" :showIndex="true" :showTotal="true"
      :getTotal="getTotal" @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange"
      @onSizeChange="onSizeChange">
      <template slot="status" slot-scope="params">
        <span v-if="params.params.status == 1">申请报销</span>
        <span v-if="params.params.status == 2">已批准</span>
        <span v-if="params.params.status == 3">已报销</span>
      </template>
    </Table>
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";

export default {
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: 'repair',
      breadcrumb: [
        { name: "财务管理", path: "/finance/estimatedProfit" },
        { name: "车队利润表", path: "/finance/estimatedProfit" },
        { name: "当月维修记录" },
      ],
      cols: [
        { prop: "license", label: "车牌号", minwidth: 120 },
        { prop: "driver", label: "司机" },
        { prop: "rstarttime", label: "维保时间", minwidth: 120 },
        { prop: "repair", label: "维保项目", minwidth: 120 },
        { prop: "money", label: "花费金额", align: 'right', className: 'pr30', minwidth: 120 },
        // { prop: "status", label: "审批状态", slot: 'status' },
      ],
      baseParams: ['month', 'license'],
      getTotalProperty: ['money'],
    };
  },
  methods: {},
  mounted() {
    this.setQueryParams();
    this.$nextTick(this.getList);
  },
};
</script>
